 module.exports = require('./core/_front')



// WEBPACK FOOTER //
// ./resources/assets/js/ui/src/front.js